var map = {
	"./denmarkRectangular.svg": 655783,
	"./denmarkRound.svg": 548260,
	"./denmarkSquare.svg": 155408,
	"./finlandRectangular.svg": 937542,
	"./finlandRound.svg": 738579,
	"./finlandSquare.svg": 76073,
	"./germanyRectangular.svg": 244300,
	"./germanyRound.svg": 849177,
	"./germanySquare.svg": 121101,
	"./norwayRectangular.svg": 431147,
	"./norwayRound.svg": 512790,
	"./norwaySquare.svg": 240415,
	"./swedenRectangular.svg": 90559,
	"./swedenRound.svg": 71955,
	"./swedenSquare.svg": 270003,
	"./ukRectangular.svg": 650610,
	"./ukRound.svg": 627223,
	"./ukSquare.svg": 585020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106626;